import { ICustomPath, IGraphicInfo } from '@src/slide/domain/ui-model/element-modeles/property/graphic-info/graphic-info.interface';
import { DeepPartial, DeepReadonly } from 'ts-essentials';
import { ICTCustomGeometry2D, ICTPath2D, DeltaOf } from '@tencent/slide-sdk-model';
import { PATH_FILL_TYPE_MAP } from '@src/slide/domain/ui-model/converter/node-property/sdk-ui-enum-map/path-fill';
import { ShapeType } from '@src/slide/infrastructure/module/dependent/shape-info/graphic-type';
import _set from 'lodash/set';
import { invertMap } from '@src/slide/infrastructure/module/independent/object/map-invert';

/**
 * 自定义图形
 */
export class CustomGraphicInfoConverter {
    /**
     * 自定义图形的sdk -> ui 映射
     * @param sdkData
     * @param uiData
     */
    public static convertPartialDataFromSdkToUi(
        sdkData: DeepReadonly<DeepPartial<ICTCustomGeometry2D>>,
        uiData: IGraphicInfo,
    ): void {
        const pathList = sdkData?.pathLst?.path?.filter(path => !!path);
        if (pathList?.length) {
            uiData.bgShape = ShapeType.custom;
            uiData.pathList = pathList.filter(path => !!path?.pathString).map((path) => {
                const obj: ICustomPath = {
                    pathString: path?.pathString,
                    width: path?.w,
                    height: path?.h,
                };
                if (path?.stroke === true || path?.stroke === false) {
                    obj.stroke = path?.stroke ? 1 : 0;
                }
                if (path?.fill) {
                    obj.fill = PATH_FILL_TYPE_MAP.get(path.fill);
                }
                return obj;
            });
        }
    }

    /**
     * 自定义图形的ui -> sdk 映射
     * @param uiData
     * @param sdkData
     */
    public static convertPartialDataFromUiToSdk(
        uiData: DeepReadonly<DeepPartial<IGraphicInfo>>,
        sdkData: DeltaOf<ICTCustomGeometry2D>,
    ): void {
        if (uiData?.pathList?.length) {
            const INVERT_PATH_FILL_TYPE_MAP = invertMap(PATH_FILL_TYPE_MAP);
            const pathLst = uiData.pathList.map((path) => {
                if (!path) {
                    return null;
                }
                const obj: ICTPath2D = {
                    pathString: path?.pathString,
                    w: path?.width,
                    h: path?.height,
                };
                if (path?.stroke || path?.stroke === 0) {
                    obj.stroke = !!path?.stroke;
                }
                if (path?.fill) {
                    obj.fill = INVERT_PATH_FILL_TYPE_MAP.get(path.fill);
                }
                return obj;
            });
            _set(sdkData, 'pathLst.path', pathLst.filter(e => !!e));
            if (uiData.rect) {
                sdkData.rect = {
                    b: { geomGuideName: uiData.rect.b },
                    l: { geomGuideName: uiData.rect.l },
                    r: { geomGuideName: uiData.rect.r },
                    t: { geomGuideName: uiData.rect.t },
                };
            }
        }
    }
}
